import './SkeletonBox-e078be7c.css';

var classes = {"SkeletonBox":"prc-Skeleton-SkeletonBox-nSZk3"};

export { classes as default };
